import { render, staticRenderFns } from "./challenges-list.vue?vue&type=template&id=22e6f498&"
import script from "./challenges-list.vue?vue&type=script&lang=js&"
export * from "./challenges-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports